import { useEffect, useState } from "react";
import { History } from "lucide-react";
import { api } from "@/lib/api";
import { QUEST_ICON } from "@/lib/quest";
import { QuestHeroes } from "@/components/quest/QuestHeroBadge";

export function QuestHistory() {
  const [h, setH] = useState(null);
  useEffect(() => { api.get("/quest/history").then(({ data }) => setH(data)).catch(() => {}); }, []);
  if (!h) return null;
  return (
    <div className="rounded-3xl bg-white border border-red-100 overflow-hidden" data-testid="quest-history">
      <div className="p-5 pb-3 flex items-center justify-between gap-3">
        <p className="font-display text-xl font-extrabold flex items-center gap-2"><History className="w-5 h-5 text-[#d2042d]" /> Bisherige Aufgaben</p>
        {h.total > 0 && <p className="text-right" data-testid="quest-history-rate"><span className="font-display text-2xl font-extrabold text-[#d2042d]">{h.rate} %</span><span className="block text-[10px] font-bold uppercase tracking-wider text-slate-400">Erfolgsquote · {h.wins}/{h.total}</span></p>}
      </div>
      {h.items.length ? (
        <ul className="divide-y divide-red-50">
          {h.items.map((q) => (
            <li key={q.id} className="p-4 space-y-1.5" data-testid={`quest-history-${q.id}`}>
              <p className="flex items-center justify-between gap-2">
                <span className="font-bold truncate">{q.title}</span>
                <span className={`shrink-0 px-2.5 py-0.5 rounded-full text-xs font-extrabold ${q.success ? "bg-emerald-50 text-emerald-700" : "bg-red-50 text-[#d2042d]"}`}>{q.success ? `Geschafft · +${q.stake}` : `Verpasst · −${q.stake}`}</span>
              </p>
              <p className="text-xs text-slate-400">{new Date(q.end).toLocaleDateString("de-DE", { timeZone: "Europe/Berlin", day: "2-digit", month: "2-digit", year: "numeric" })} · {q.participants} Mitmacher</p>
              <p className="flex flex-wrap gap-x-3 gap-y-1 text-xs font-semibold text-slate-600">
                {q.goals.map((g) => <span key={g.kind} className={g.done ? "text-emerald-700" : ""}>{QUEST_ICON[g.kind]} {g.count}/{g.goal}{g.done ? " ✓" : ""}</span>)}
              </p>
              <QuestHeroes heroes={q.heroes} testId={`quest-history-heroes-${q.id}`} />
            </li>
          ))}
        </ul>
      ) : <p className="p-6 pt-2 text-center text-sm text-slate-400" data-testid="quest-history-empty">Das ist die erste Community-Aufgabe – hier erscheinen bald alle Ergebnisse.</p>}
    </div>
  );
}
